// extracted by mini-css-extract-plugin
export default {"iconButton":"ViewModeToggle_iconButton__LIWQm"};